export const UPLOAD_PLUGIN_KEY = 'upload-plugin-key';
